import React, { useState, useEffect } from 'react';
import {
  Button,
  Grid
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

import { Created, Ready, Payment, Completed } from 'constants/status';

const useStyles = makeStyles((theme) => ({
  greenButton: {
    backgroundColor: green[600],
    color: "#ffffff",
    '&:hover': {
      backgroundColor: green[600],
      color: "#ffffff"
    }
  }
}));

const options = [Created, Ready, Payment, Completed];

const StatusButton = (props) => {

  const classes = useStyles();

  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    setSelectedIndex(options.findIndex(option => option === props.status));

  }, [props.status]);

  const handleButtonClick = () => {
    if(options[selectedIndex] === Payment && props.isStandard && !props.salesOrderInfo.paymentDate) {
      props.updateSalesOrderPayments(props.salesOrderInfo);
    }
  };

  return (
    <Grid item xs={12}>
      <Button
        className={options[selectedIndex] === Completed ? classes.greenButton: null}
        variant="contained"
        color="primary"
        aria-label="status button"
        onClick={() => handleButtonClick()}
      >
        {options[selectedIndex]}
      </Button>
    </Grid>
  )
};

export default StatusButton;